import axios from "axios"

export const SystemDataApi = {
    async Province(){
        const response = await axios.get(`/api/systemdata/province/list`)
        return response
    },
    async District(data){
        const response = await axios.get(`/api/systemdata/district/list/${data}`)
        return response
    },
    async CalculateSHA1(data){
        const response = await axios.post('/api/systemdata/calculate/sha1',data)
        return response
    },
    async CalculateSHA512(data){
        const response = await axios.post('/api/systemdata/calculate/sha512',data)
        return response
    },
    async CalculateSHA1ASCII(data){
        const response = await axios.post('/api/systemdata/calculate/sha1ascii',data)
        return response
    }
}